
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Button } from '@/components/ui/button';

interface OrganisationErrorProps {
  error: string | null;
}

const OrganisationError: React.FC<OrganisationErrorProps> = ({ error }) => {
  const navigate = useNavigate();
  
  const goBack = () => {
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-center items-center h-64">
          <div className="text-center">
            <p className="text-lg text-red-500 mb-4">{error || 'Organisation not found'}</p>
            <Button onClick={goBack}>Return to Admin Dashboard</Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OrganisationError;
